module.exports = __webpack_public_path__ + "img/img08.a8eb3aed.png";